import axios from "axios";

const API_URL = "https://sipuas.online/api";

const api = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 30000,
  withCredentials: true,
});

// Error interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      console.error("API Error:", error.response.status, error.response.data);
    } else if (error.request) {
      console.error("Network Error - No response received");
    } else {
      console.error("Error:", error.message);
    }
    return Promise.reject(error);
  }
);

// ========================================
// AUTHENTICATION - FLAT URLS
// ========================================
export const login = (username, password) =>
  api.post("/login.php", { username, password });

export const changePassword = (data) => api.post("/change_password.php", data);

export const fixPassword = (data) => api.post("/fix_password.php", data);

// ========================================
// SURVEY - FLAT URLS
// ========================================
export const getSurveyDetail = (survey_id) =>
  api.get(`/get_survey_detail.php?survey_id=${survey_id}`);

export const getPertanyaan = () => api.get("/get_pertanyaan.php");

export const getGuruForSurvey = (siswa_id, semester) =>
  api.get(`/get_guru.php?siswa_id=${siswa_id}&semester=${semester}`);

export const submitSurvey = (data) => api.post("/submit.php", data);

export const getHasilSurvey = (semester) =>
  api.get(`/get_hasil.php?semester=${semester}`);

export const getResumeGuru = (guru_id, semester) =>
  api.get(`/get_resume_guru.php?guru_id=${guru_id}&semester=${semester}`);

// ========================================
// MASTER DATA - FLAT URLS
// ========================================
export const getMasterData = (action) => api.get(`/data.php?action=${action}`);

export const addPenugasan = (data) =>
  api.post("/data.php?action=add_penugasan", data);

export const deletePenugasan = (id) =>
  api.post("/data.php?action=delete_penugasan", { id });

// Guru
export const getGuru = () => api.get("/data.php?action=get_guru");

export const addGuru = (data) => api.post("/data.php?action=add_guru", data);

export const updateGuru = (data) =>
  api.post("/data.php?action=update_guru", data);

export const deleteGuru = (id) =>
  api.post("/data.php?action=delete_guru", { id });

// Siswa
export const getSiswa = () => api.get("/data.php?action=get_siswa");

export const addSiswa = (data) => api.post("/data.php?action=add_siswa", data);

export const updateSiswa = (data) =>
  api.post("/data.php?action=update_siswa", data);

export const deleteSiswa = (id) =>
  api.post("/data.php?action=delete_siswa", { id });

// Semester
export const getAllSemester = () => api.get("/data.php?action=get_semester");

export const getActiveSemester = () =>
  api.get("/data.php?action=get_active_semester");

export const addSemester = (data) =>
  api.post("/data.php?action=add_semester", data);

export const setActiveSemester = (id) =>
  api.post("/data.php?action=set_active_semester", { id });

export const deleteSemester = (id) =>
  api.post("/data.php?action=delete_semester", { id });

// ========================================
// DASHBOARD - FLAT URL
// ========================================
export const getDashboardData = () => api.get("/dashboard.php");

// ========================================
// FILE UPLOAD - FLAT URLS
// ========================================
export const uploadFoto = (formData) =>
  api.post("/upload_foto.php", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

export const deleteFoto = (data) => api.post("/delete_foto.php", data);

// ========================================
// HELPER: Get Photo URL
// ========================================
export const getPhotoUrl = (filename, type = "guru") => {
  if (!filename) return null;
  return `https://sipuas.online/uploads/${type}/${filename}`;
};

export default api;
